var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#efefef","border-radius":"10px","padding-left":"10px","border":"1px solid silver"}},[_c('OpenLink',{attrs:{"Editor":_vm.Editor}}),_c('EditLink',{attrs:{"Editor":_vm.Editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }